import { createContext } from 'react';

const DeleteCompareModalContext = createContext(void 0);

DeleteCompareModalContext.displayName = 'context(DeleteCompareModal)';

export default DeleteCompareModalContext;